import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "stream-loading"
};
const _hoisted_2 = {
  class: "stream-panel"
};
const _hoisted_3 = {
  class: "stream-tabs"
};
const _hoisted_4 = {
  class: "count-pill"
};
const _hoisted_5 = {
  class: "count-pill"
};
const _hoisted_6 = {
  class: "stream-body"
};
const _hoisted_7 = {
  class: "stream-empty"
};
const _hoisted_8 = {
  class: "stream-body"
};
const _hoisted_9 = {
  class: "stream-empty"
};
const _hoisted_10 = {
  class: "no-results-state"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_button_group = _resolveComponent("b-button-group");
  const _component_Livestream = _resolveComponent("Livestream");
  const _component_Premiere = _resolveComponent("Premiere");
  const _component_b_container = _resolveComponent("b-container");
  return _openBlock(), _createBlock(_component_b_container, {
    fluid: "",
    class: "stream-list-shell"
  }, {
    default: _withCtx(() => [$props.showloading && (!$data.checkedLive || !$data.checkedPremiere) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_spinner), _cache[4] || (_cache[4] = _createElementVNode("div", {
      class: "loading-copy"
    }, [_createElementVNode("strong", null, "Loading Upcoming Events"), _createElementVNode("span", null, "Please wait while we fetch the latest schedule.")], -1))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_b_button_group, {
      class: "stream-button-group"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_button, {
        onClick: _cache[0] || (_cache[0] = $event => $data.streamList = 'live'),
        class: _normalizeClass([$data.streamList == 'live' ? 'tab-active' : '', "stream-list-btn"])
      }, {
        default: _withCtx(() => [_cache[5] || (_cache[5] = _createTextVNode(" Livestreams ", -1)), _createElementVNode("span", _hoisted_4, _toDisplayString($data.liveCount), 1)], undefined, true),
        _: 1
      }, 8, ["class"]), _createVNode(_component_b_button, {
        onClick: _cache[1] || (_cache[1] = $event => $data.streamList = 'premiere'),
        class: _normalizeClass([$data.streamList == 'premiere' ? 'tab-active' : '', "stream-list-btn"])
      }, {
        default: _withCtx(() => [_cache[6] || (_cache[6] = _createTextVNode(" Premieres ", -1)), _createElementVNode("span", _hoisted_5, _toDisplayString($data.premiereCount), 1)], undefined, true),
        _: 1
      }, 8, ["class"])], undefined, true),
      _: 1
    })]), _withDirectives(_createElementVNode("div", _hoisted_6, [_withDirectives(_createVNode(_component_Livestream, {
      limit: $props.limit,
      channelId: $props.channel,
      onListCount: _cache[2] || (_cache[2] = $event => $options.setCount($event, 0))
    }, null, 8, ["limit", "channelId"]), [[_vShow, $data.liveCount > 0]]), _withDirectives(_createElementVNode("div", _hoisted_7, [...(_cache[7] || (_cache[7] = [_createElementVNode("h4", null, "No Scheduled Livestreams at this time", -1)]))], 512), [[_vShow, $data.liveCount == 0]])], 512), [[_vShow, $data.streamList == 'live']]), _withDirectives(_createElementVNode("div", _hoisted_8, [_withDirectives(_createVNode(_component_Premiere, {
      limit: $props.limit,
      channelId: $props.channel,
      onListCount: _cache[3] || (_cache[3] = $event => $options.setCount($event, 1))
    }, null, 8, ["limit", "channelId"]), [[_vShow, $data.premiereCount > 0]]), _withDirectives(_createElementVNode("div", _hoisted_9, [...(_cache[8] || (_cache[8] = [_createElementVNode("h4", null, "No Scheduled Premieres at this time", -1)]))], 512), [[_vShow, $data.premiereCount == 0]])], 512), [[_vShow, $data.streamList == 'premiere']])], 512), [[_vShow, $data.liveCount > 0 || $data.premiereCount > 0]]), _withDirectives(_createElementVNode("div", _hoisted_10, [...(_cache[9] || (_cache[9] = [_createElementVNode("div", {
      class: "no-results-icon"
    }, [_createElementVNode("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.8"
    }, [_createElementVNode("rect", {
      x: "3",
      y: "4",
      width: "18",
      height: "18",
      rx: "2"
    }), _createElementVNode("line", {
      x1: "16",
      y1: "2",
      x2: "16",
      y2: "6"
    }), _createElementVNode("line", {
      x1: "8",
      y1: "2",
      x2: "8",
      y2: "6"
    }), _createElementVNode("line", {
      x1: "3",
      y1: "10",
      x2: "21",
      y2: "10"
    })])], -1), _createElementVNode("h2", null, "No scheduled events found", -1), _createElementVNode("p", null, "Check back again soon for new livestreams and premieres.", -1)]))], 512), [[_vShow, $data.liveCount == 0 && $data.premiereCount == 0 && $data.checkedLive && $data.checkedPremiere && $props.showNoResults]])], undefined, true),
    _: 1
  });
}